import {
  all, call, put, select, takeLatest,
} from 'redux-saga/effects';

import { cloneDeep } from 'lodash';

import { generatePath } from 'react-router-dom';
import { message } from 'antd';
import { useSelector } from 'react-redux';
import React from 'react';
import moment from 'moment';
import { constants } from '../actions/constants/pacientes.constants';
import { constants as constantsOpto } from '../actions/constants/fichaOptometrica.constants';
import { constants as constantsContact } from '../actions/constants/fichaContactologica.constants';
import { authRequest, authRequestv2, authRequestGioCore, authRequestGioApi } from '../../helpers/request.helper';
import fileNameDownloadHelper from '../../helpers/fileNameDownload.helper';
import { ROUTE_PACIENTES_FILE, ROUTE_PACIENTES_GDPR } from '../../routes.constants';
import { buildUrl } from '../../modules/pacientes/utilities/buildUrl';
import history from '../../history';
import printJS from 'print-js';

function* initWorkspace({ payload }: any) {
  yield put({
    type: constants.PACIENTES_INIT_WORKSPACE_SUCCESS,
    payload,
  });
}


function* setWorkspace({ payload }: any) {
  yield put({
    type: constants.PACIENTES_GET_PACIENTES_REQUEST,
    payload,
  });
}

function* setKeyword({ payload }: any) {
  yield put({
    type: constants.PACIENTES_SET_KEYWORD_STATE,
    payload,
  });
}

function* getPacientes({ payload }: any) {
  const {
    tiendaId, keyword, page, pageSize, sorter,
  } = payload;

  // TODO: Fixed provisional para no actualizar la vista todo el rato
  delete payload.sorter; // TODO: Actualmente no se utiliza en la pantalla de paciente lista. Si se quita existe un fallo en el JSON.stringify(newPayload);
  const storageTiendaId = sessionStorage.getItem('infoOldTiendaId');
  let oldTiendaId = tiendaId;
  let newPayload = {};
  if(storageTiendaId !== null) {
    oldTiendaId = JSON.parse(storageTiendaId);
    newPayload = {...payload, tiendaId: oldTiendaId};
  } else {
    newPayload = payload;
  }
  if(JSON.stringify(newPayload) === sessionStorage.getItem('payloadGetPacientes')) {
    const oldPacientes = JSON.parse(sessionStorage.getItem('infoGetPacientes') || '[]');
    const oldTotalPacientes = JSON.parse(sessionStorage.getItem('infoGetTotalPacientes') || '0');
    yield put({ type: constants.PACIENTES_GET_PACIENTES_REQUEST_SUCCESS, payload: { pacientes: oldPacientes, totalPacientes: oldTotalPacientes } });
    return;
  }



  let filter = [];
  let search = {};
  if(tiendaId !== -1){
    filter.push({"field": "tienda_id","operator": "=","value": tiendaId});
  }
  if(keyword !== ''){
    // search.push({"field": "nombre_completo", "operator": "contains", "value": keyword})
    search = {"criteria": keyword};
  }
  let sort = [];
  if (sorter && sorter.order) {
    sort.push({"field": sorter.columnKey,"sort": sorter.order === 'ascend' ? 'ASC' : 'DESC'});
  } else{
    sort.push({"field": "id","sort": 'DESC'});
  }
  const selectFields = [ "id","tienda_id", "nombre_completo", "documento_identidad", "nombre_1", "apellido_1",
   "nombre_sucursal", "telefono_1", "movil", "email", "fecha_ultimo_encargo", "fecha_ultima_gradopt",
   "fecha_ultima_gradcontac","rgpd_firmada", "fecha_nacimiento", "firmado_lopd" ];
  let select:any = [];
  selectFields.map((element) => {
    select.push({"field": element});
  })
  const params = {
    url: buildUrl('get_paciente_search'),
    method: 'POST',
    body: {
      "data": {
          "pagination": {
              "page": page - 1,
              "start": 0,
              "limit": pageSize
          },
          "select": select,
          "search": search,
          "filter": filter,
          "order": sort
      }
   },
  };

  try {
    const {
      data: data,
    } = yield call(authRequestGioApi, params);
    const {data: pacientes, metadata: metadatos} = data;
    const { count: totalPacientes } = metadatos;

    yield put({ type: constants.PACIENTES_GET_PACIENTES_REQUEST_SUCCESS, payload: { pacientes, totalPacientes } });

    // TODO: Fixed provisional para no actualizar la vista todo el rato
    sessionStorage.setItem('payloadGetPacientes', JSON.stringify(newPayload));
    sessionStorage.setItem('infoGetPacientes', JSON.stringify(pacientes));
    sessionStorage.setItem('infoGetTotalPacientes', JSON.stringify(totalPacientes));
    sessionStorage.setItem('infoOldTiendaId', JSON.stringify(oldTiendaId));
    if (totalPacientes === "1") {
      history.push(generatePath(ROUTE_PACIENTES_FILE, { pacienteId: pacientes[0].id }));
    }
  } catch (error) {
    yield put({ type: constants.PACIENTES_GET_PACIENTES_REQUEST_FAILURE, payload: error });
  }
}

function* getPaciente({ payload }: any) {
  const { tiendaId, pacienteId } = payload;
    let filter = [];
    if( pacienteId != null ){
      filter.push({"field": "id","operator": "=","value": pacienteId});
    }
    // const selectFields = [ "id", "nombre_completo", "documento_identidad", "genero", "es_empresa",
    // "email", "telefono_1", "movil", "telefono_2", "nombre_1", "apellido_1","apellido_2", "nombre_sucursal",
    // "documento_identidad_id", "tipo_identificacion_std", "cdg_pais_origen", "direccion", "pais",
    // "provincia","poblacion", "codigo_postal", "str_profesion", "cod_profesion", "cod_grupo_cliente",
    // "exento_iva","cod_paciente_pagador", "cod_paciente_acompanante", "nombre_paciente_pagador", "nombre_paciente_acompanante",
    // "fecha_nacimiento","rgpd_firmada", "rgpd_fecha_inactivo", "rgpd_com_comerciales", "enviar_mailing", "enviar_sms",
    // "enviar_email","tiene_hijos_menores_quince", "anyo_nacimiento_ult_hijo, notas, campos_dinamicos" ];

    // let select:any = [];
    // selectFields.map((element) => {
    //   select.push({"field": element});
    // })
    const params = {
      url: buildUrl('get_paciente_v2'),
      method: 'POST',
      body: {
        "data": {
            "pagination": {
                "page": 0,
                "start": 0,
                "limit": 1
            },
            // "select": select,
            "filter": filter,
        }
    },
  };
  const oldPaciente = JSON.parse(sessionStorage.getItem('infoPaciente') || 'null')
  // TODO: Fixed provisional. Almacenar la información en el session storage para que no se repitan las llamadas si ya tenemos la información.
  if(oldPaciente !== null && oldPaciente.id === pacienteId) {
    yield put({ type: constants.PACIENTES_GET_PACIENTE_REQUEST_SUCCESS, payload: oldPaciente });
  } else {
    try {
      const {
        data: data,
      } = yield call(authRequestGioApi, params);
      const {data: pacientes} = data;
      // TODO: Delete when service was implemented
      // pacientes[0].mutuas = [{
      //   codigo_cliente_grupo: 8,
      //   beneficiario: '123214',
      // },
      // {
      //   codigo_cliente_grupo: 9,
      //   beneficiario: '123456',
      // },
      // ];
      // TODO: Review this behavior
      // const filterPatients = pacientes.filter((paciente: any) => paciente.id === pacienteId);
      yield put({ type: constants.PACIENTES_GET_PACIENTE_REQUEST_SUCCESS, payload: pacientes[0] });
      sessionStorage.setItem('infoPaciente', JSON.stringify(pacientes[0]))

    } catch (error) {
      yield put({ type: constants.PACIENTES_GET_PACIENTE_REQUEST_FAILURE, payload: error });
    }
  }
}

function* getPacientesProfesiones() {
  const params = {
    url: buildUrl('get_pacientes_profesiones'),
    method: 'POST',
    body: {},
  };
  const oldProfesiones = JSON.parse(sessionStorage.getItem('infoProfesiones') || 'null')
  // TODO: Fixed provisional. Almacenar la información en el session storage para que no se repitan las llamadas si ya tenemos la información.
  if(oldProfesiones !== null) {
    yield put({ type: constants.PACIENTES_GET_PACIENTES_PROFESIONES_SUCCESS, payload: oldProfesiones });
  } else {
    try {
      const {
        profesiones,
      } = yield call(authRequest, params);
      yield put({ type: constants.PACIENTES_GET_PACIENTES_PROFESIONES_SUCCESS, payload: profesiones });
      sessionStorage.setItem('infoProfesiones', JSON.stringify(profesiones))
    } catch (error) {
      yield put({ type: constants.PACIENTES_GET_PACIENTES_PROFESIONES_FAILURE, payload: error });
    }
  }
}

function* getPacientesTiendas() {
  const params = {
    url: buildUrl('get_pacientes_tiendas'),
    method: 'POST',
    body: {},
  };

  try {
    const allTiendas = [];
    let total = 0;
    do {
      const formData = new FormData();
      formData.append('comienzo', allTiendas.length.toString());
      formData.append('limite', String(50));
      params.body = formData;
      const { totalR, datos } = yield call(authRequest, params);
      allTiendas.push(...datos);
      total = totalR;
    } while (allTiendas.length < total);

    yield put({ type: constants.PACIENTES_GET_PACIENTES_TIENDAS_SUCCESS, payload: allTiendas });
  } catch (error) {
    yield put({ type: constants.PACIENTES_GET_PACIENTES_TIENDAS_FAILURE, payload: error });
  }
}

function* getPacienteGrupos() {
  const params = {
    url: buildUrl('get_pacientes_grupos'),
    method: 'POST',
    body: {},
  };
  const oldGruposClientes = JSON.parse(sessionStorage.getItem('infoGruposCliente') || 'null')
  // TODO: Fixed provisional. Almacenar la información en el session storage para que no se repitan las llamadas si ya tenemos la información.
  if(oldGruposClientes !== null) {
    yield put({ type: constants.PACIENTES_GET_PACIENTES_GROUPS_SUCCESS, payload: oldGruposClientes });
  } else {
    try {
      const {
        grupos_cliente,
      } = yield call(authRequest, params);
      yield put({ type: constants.PACIENTES_GET_PACIENTES_GROUPS_SUCCESS, payload: grupos_cliente });
      sessionStorage.setItem('infoGruposCliente', JSON.stringify(grupos_cliente))
    } catch (error) {
      yield put({ type: constants.PACIENTES_GET_PACIENTES_GROUPS_FAILURE, payload: error });
    }
  }
}

function* getPacienteRGPD({ payload }: any) {
  const { pacienteId } = payload;

  const params = {
    url: buildUrl('get_rgpd', pacienteId),
    method: 'GET',
    body: { pacienteId },

  };

  try {
    // @ts-ignore
    const response = yield call(authRequest, params);
    yield put({ type: constants.PACIENTES_GET_PACIENTE_RGPD_SUCCESS, payload: { rgpd: response } });
  } catch (error) {
    yield put({ type: constants.PACIENTES_GET_PACIENTE_RGPD_FAILURE, payload: error });
  }
}
function* openPacienteUrlAwsRGPD({ payload }: any) {
  const { pacienteId } = payload;
  const formData = new FormData();
  formData.append('pacienteId', pacienteId);
  formData.append('responseContentDisposition', 'inline');
  const params = {
    url: buildUrl('get_url_pdf_aws_rgpd'),
    method: 'POST',
    body: formData,
  };

  try {
    // @ts-ignore
    const response = yield call(authRequestv2, params);
    window.open(response.data.publicUrl);

    yield put({ type: constants.PACIENTES_OPEN_PACIENTE_URL_AWS_RGPD_SUCCESS, payload: { rgpd: response.data } });
  } catch (error) {
    yield put({ type: constants.PACIENTES_OPEN_PACIENTE_URL_AWS_RGPD_FAILURE, payload: error });
  }

}
function* openPacienteUrlRGPD({ payload }: any) {
  const { pacienteId } = payload;
  const formData = new FormData();
  formData.append('pacienteId', pacienteId);
  formData.append('responseContentDisposition', 'inline');
  const params = {
    url: buildUrl('get_url_pdf_rgpd'),
    method: 'POST',
    body: formData,
    responseType: 'blob',
  };

  try {
    // @ts-ignore
    const response = yield call(authRequestv2, params);
    const blobUrl = URL.createObjectURL(response.data);
    window.open(blobUrl, '_blank');

    yield put({ type: constants.PACIENTES_OPEN_PACIENTE_URL_RGPD_SUCCESS, payload: { rgpd: response.data } });
  } catch (error) {
    yield put({ type: constants.PACIENTES_OPEN_PACIENTE_URL_RGPD_FAILURE, payload: error });
  }
}

function* downloadPacienteAwsRGPD({ payload }: any) {
  const { pacienteId } = payload;
  const formData = new FormData();
  formData.append('pacienteId', pacienteId);
  formData.append('responseContentDisposition', 'attachment');
  const params = {
    url: buildUrl('get_url_pdf_aws_rgpd'),
    method: 'POST',
    body: formData,
  };

  try {
    // @ts-ignore
    const response = yield call(authRequestv2, params);
    const element = document.createElement('a');
    element.href = response.data.publicUrl;
    document.body.append(element);
    element.click();

    yield put({ type: constants.PACIENTES_DOWNLOAD_PACIENTE_URL_AWS_RGPD_SUCCESS, payload: { rgpd: response.data } });
  } catch (error) {
    yield put({ type: constants.PACIENTES_DOWNLOAD_PACIENTE_URL_AWS_RGPD_FAILURE, payload: error });
  }
}

function* downloadPacienteRGPD({ payload }: any) {
  const { pacienteId } = payload;
  const formData = new FormData();
  formData.append('pacienteId', pacienteId);
  formData.append('responseContentDisposition', 'attachment');
  const params = {
    url: buildUrl('get_url_pdf_rgpd'),
    method: 'POST',
    body: formData,
    responseType: 'blob',
  };

  try {
    // @ts-ignore
    const response = yield call(authRequestv2, params);
    const filename = fileNameDownloadHelper(response);
    const blobUrl = URL.createObjectURL(response.data);
    var link=document.createElement('a');
    link.href=blobUrl;
    link.setAttribute("download", filename);
    document.body.appendChild(link);
    link.click();

    yield put({ type: constants.PACIENTES_DOWNLOAD_PACIENTE_URL_RGPD_SUCCESS, payload: { rgpd: response.data } });
  } catch (error) {
    yield put({ type: constants.PACIENTES_DOWNLOAD_PACIENTE_URL_RGPD_FAILURE, payload: error });
  }
}

const getPacientesRGPDCondicionesState = (state: any) => state.pacientesWorkspace.grpd;
const getPacientesEncargos = (state: any) => state.pacientesWorkspace.encargos;

function* savePacienteRGPD({ payload }: any) {
  // @ts-ignore
  const grpdConditions = yield select(getPacientesRGPDCondicionesState);
  const {
    pacienteId, firma,
  } = payload;

  const formData = new FormData();
  formData.append('paciente_id', pacienteId);
  formData.append('firma', firma, 'firma.png');
  formData.append('condiciones', grpdConditions.condiciones);
  formData.append('condiciones_adicionales',
    JSON.stringify({ checkboxes: grpdConditions.condicionesAdicionales }));
  const params = {
    url: buildUrl('guardar_rgpd', pacienteId),
    method: 'POST',
    body: formData,
  };

  try {
    // @ts-ignore
    const response = yield call(authRequest, params);
    yield put({ type: constants.PACIENTES_SAVE_PACIENTE_RGPD_SUCCESS, payload: response });
    const filePath = generatePath(ROUTE_PACIENTES_FILE, { pacienteId });
    message.success('Firma Guardada');
    sessionStorage.removeItem('infoPatientFileId');
    sessionStorage.removeItem('infoPaciente');
    yield call(history.push, filePath);
  } catch (error) {
    yield put({ type: constants.PACIENTES_SAVE_PACIENTE_RGPD_FAILURE, payload: error });
  }
}

const getAgenteId = (state: any) => state.auth.user.user_info.usuario_id;

function* comprobarPacienteDuplicado({ payload }: any) {
  const {data, signRgpd, print} = payload;
  try{
    const {documento_identidad} = data;

    let filter = [];
    if( documento_identidad != null ){
      filter.push({"field": "documento_identidad","operator": "=","value": documento_identidad});
    }
    const params = {
      url: buildUrl('get_paciente_v2'),
      method: 'POST',
      body: {
        "data": {
            "filter": filter,
            "count": true
        }
    },
    };
    // @ts-ignore
    const { data: datos } = yield call(authRequestGioApi, params);
    const respuesta = datos.metadata.count > 0 ? true : false;

    yield put({ type: constants.COMPROBAR_PACIENTE_DUPLICADO_SUCCESS, payload: respuesta });
  } catch (error) {
    if (error.data && error.data.error_message) {
      message.error(error.data.error_message);
    }
    yield put({ type: constants.COMPROBAR_PACIENTE_DUPLICADO_FAILURE, payload: error });
  }
}
function* createPaciente({ payload }: any) {
  const { data, signRgpd, print } = payload;
  const {
    nombre_1: nombre,
    genero,
    dinamicos,
    mutuas,
    cod_paciente_acompanante,
    cod_paciente_pagador,
    fecha_nacimiento,
    anyo_nacimiento_ult_hijo,
    avatar,
    ...otherFields
  } = data;

  const formData = new FormData();
  // @ts-ignore
  const agente_id = yield select(getAgenteId);
  const camposDinamicosToSend: any = [];
  if (dinamicos) {
    Object.entries(dinamicos).forEach(([campo_id, valor]) => {
      if (valor !== null && valor !== undefined) camposDinamicosToSend.push({ campo_id, valor });
    });
  }
  formData.append('agente_id', agente_id);
  formData.append('nombre', nombre);
  formData.append('genero', genero);
  formData.append('avatar', avatar);
  // formData.append('avatar_src', '../../assets/img');

  if (cod_paciente_pagador) formData.append('paciente_pagador_id', cod_paciente_pagador);
  if (cod_paciente_acompanante) formData.append('codigo_tutor', cod_paciente_acompanante);
  if (fecha_nacimiento) formData.append('fecha_nacimiento', moment.isMoment(fecha_nacimiento) ? fecha_nacimiento.format('Y-MM-DD') : fecha_nacimiento);
  if (anyo_nacimiento_ult_hijo) formData.append('anyo_nacimiento_ult_hijo', moment.isMoment(anyo_nacimiento_ult_hijo) ? anyo_nacimiento_ult_hijo.format('Y') : anyo_nacimiento_ult_hijo);
  Object.entries(otherFields).forEach(([key, value]) => {
    // @ts-ignore
    if (value !== null && value !== undefined) formData.append(key, value);
  });

  if (camposDinamicosToSend.length > 0) formData.append('camposDinamicos', JSON.stringify(camposDinamicosToSend));

  formData.append('mutuas', JSON.stringify({
    seleccionadas: mutuas.filter(({ beneficiario, codigo_cliente_grupo }: any) => {
      if (beneficiario !== '' && codigo_cliente_grupo !== '') {
        return ({
          codigo_cliente_grupo,
          beneficiario,
        });
      }
    }),
  }));


  const params = {
    url: buildUrl('guardar_paciente'),
    method: 'POST',
    body: formData,
  };

  try {
    const { id } = yield call(authRequest, params);
    yield put({ type: constants.PACIENTES_CREATE_PACIENTE_REQUEST_SUCCESS });
    if (signRgpd === true && print === false) {
      const filePath = generatePath(ROUTE_PACIENTES_GDPR, { pacienteId: id });
      yield call(history.push, filePath);
    } else if (signRgpd === false && print === true) {
      const filePath = generatePath(ROUTE_PACIENTES_FILE, { pacienteId: id });
      yield call(history.push, {
        pathname: filePath,
        search: `?print=${print}`,
      });
    } else {
      const filePath = generatePath(ROUTE_PACIENTES_FILE, { pacienteId: id });
      yield call(history.push, filePath);
    }
  } catch (error) {
    if (error.data && error.data.error_message) {
      message.error(error.data.error_message);
    }
    yield put({ type: constants.PACIENTES_CREATE_PACIENTE_REQUEST_FAILURE, payload: error });
  }
}

function* updatePaciente({ payload }: any) {
  const { pacienteId, data, campos_dinamicos } = payload;
  const {
    nombre_1: nombre,
    genero,
    dinamicos,
    mutuas,
    cod_paciente_acompanante,
    cod_paciente_pagador,
    fecha_nacimiento,
    anyo_nacimiento_ult_hijo,
    avatar,
    ...otherFields
  } = data;

  const formData = new FormData();
  // @ts-ignore
  const agente_id = yield select(getAgenteId);
  const camposDinamicosToSend: any = [];
  if (dinamicos) {
    Object.entries(dinamicos).forEach(([campo_id, valor]) => {
      const cd = campos_dinamicos.find((e:any) => e.campo_id == campo_id);
      if (valor !== null && valor !== undefined && cd) camposDinamicosToSend.push({ campo_id: cd.campo_id, valor });
    });
  }

  formData.append('paciente_id', pacienteId);
  formData.append('agente_id', agente_id);
  formData.append('nombre', nombre);
  formData.append('genero', genero);
  formData.append('avatar', avatar);
  // formData.append('avatar_src', '../../assets/img');

  if (cod_paciente_pagador) formData.append('paciente_pagador_id', cod_paciente_pagador);
  if (cod_paciente_acompanante) formData.append('codigo_tutor', cod_paciente_acompanante);
  if (fecha_nacimiento) formData.append('fecha_nacimiento', moment.isMoment(fecha_nacimiento) ? fecha_nacimiento.format('Y-MM-DD') : fecha_nacimiento);
  if (anyo_nacimiento_ult_hijo) formData.append('anyo_nacimiento_ult_hijo', moment.isMoment(anyo_nacimiento_ult_hijo) ? anyo_nacimiento_ult_hijo.format('Y') : anyo_nacimiento_ult_hijo);
  Object.entries(otherFields).forEach(([key, value]) => {
    // @ts-ignore
    if (value !== null && value !== undefined) formData.append(key, value);
  });

  if (camposDinamicosToSend.length > 0) formData.append('camposDinamicos', JSON.stringify(camposDinamicosToSend));

  formData.append('mutuas', JSON.stringify({
    seleccionadas: mutuas.filter(({ beneficiario, codigo_cliente_grupo }: any) => {
      if (beneficiario !== '' && codigo_cliente_grupo !== '') {
        return ({
          codigo_cliente_grupo,
          beneficiario,
        });
      }
    }),
  }));

  const params = {
    url: buildUrl('guardar_paciente'),
    method: 'POST',
    body: formData,
  };

  try {
    yield call(authRequest, params);
    yield put({ type: constants.PACIENTES_UPDATE_PACIENTE_REQUEST_SUCCESS });
    const filePath = generatePath(ROUTE_PACIENTES_FILE, { pacienteId });
    sessionStorage.removeItem('infoNewPatient');
    sessionStorage.removeItem('infoPatientFileId');
    sessionStorage.removeItem('infoPaciente');
    yield call(history.push, {
      pathname: filePath,
      search: '?saved=success',
    });
  } catch (error) {
    yield put({ type: constants.PACIENTES_UPDATE_PACIENTE_REQUEST_FAILURE, payload: error });
  }
}

function* getPacienteNotas({ payload }: any) {
  const { pacienteId } = payload;
  const params = {
    url: buildUrl('get_notas', pacienteId),
    method: 'GET',
  };
  try {
    const {
      notas,
    } = yield call(authRequest, params);


    yield put({ type: constants.PACIENTES_GET_PACIENTE_NOTAS_REQUEST_SUCCESS, payload: notas });
  } catch (error) {
    yield put({ type: constants.PACIENTES_GET_PACIENTE_NOTAS_REQUEST_FAILURE, payload: error });
  }
}

function* setPacienteNotas({ payload }: any) {
  const { pacienteId, texto } = payload;
  const formData = new FormData();
  formData.append('texto', texto);
  const params = {
    url: buildUrl('paciente_notas', pacienteId),
    method: 'POST',
    body: formData,
  };

  const {
    notas,
  } = yield call(authRequest, params);
  const { observacion } = notas;

  try {
    yield put({ type: constants.PACIENTES_SET_PACIENTE_NOTAS_REQUEST_SUCCESS, payload: observacion });
  } catch (error) {
    yield put({ type: constants.PACIENTES_SET_PACIENTE_NOTAS_REQUEST_FAILURE, payload: error });
  }
}

// TODO: Esto va?
function* getPacienteInsurances() {
  const params = {
    url: 'api/mutuas/buscar',
    method: 'GET',
  };

  try {
    const {
      datos: insurances,
    } = yield call(authRequest, params);
    yield put({ type: constants.PACIENTES_GET_PACIENTE_INSURANCES_REQUEST_SUCCESS, payload: insurances });
  } catch (error) {
    yield put({ type: constants.PACIENTES_GET_PACIENTE_INSURANCES_REQUEST_FAILURE, payload: error });
  }
}

function* getPacientesPaises() {
  const params = {
    url: buildUrl('buscar_paises'),
    method: 'POST',
    body: {},
  };
  const oldPaises = JSON.parse(sessionStorage.getItem('infoPaises') || 'null')
  // TODO: Fixed provisional. Almacenar la información en el session storage para que no se repitan las llamadas si ya tenemos la información.
  if(oldPaises !== null) {
    yield put({ type: constants.PACIENTES_GET_PACIENTES_PAISES_SUCCESS, payload: oldPaises });
  } else {
    try {
      const {
        paises,
      } = yield call(authRequest, params);
      yield put({ type: constants.PACIENTES_GET_PACIENTES_PAISES_SUCCESS, payload: paises });
      sessionStorage.setItem('infoPaises', JSON.stringify(paises))
    } catch (error) {
      yield put({ type: constants.PACIENTES_GET_PACIENTES_PAISES_FAILURE, payload: error });
    }
  }
}

function* getPacientesProvincias({ payload }: any) {
  const { codigoPais } = payload;
  const params = {
    url: buildUrl('buscar_provincias', codigoPais),
    method: 'GET',
    body: {},
  };

  try {
    const {
      provincias,
    } = yield call(authRequest, params);
    yield put({ type: constants.PACIENTES_GET_PACIENTES_PROVINCIAS_SUCCESS, payload: provincias });
  } catch (error) {
    yield put({ type: constants.PACIENTES_GET_PACIENTES_PROVINCIAS_FAILURE, payload: error });
  }
}

function* getPacientesMutuas() {
  const params = {
    url: buildUrl('buscar_mutuas'),
    method: 'POST',
    body: {},
  };

  try {
    const {
      datos: mutuas,
    } = yield call(authRequest, params);

    yield put({ type: constants.PACIENTES_GET_PACIENTES_MUTUAS_SUCCESS, payload: mutuas });
  } catch (error) {
    yield put({ type: constants.PACIENTES_GET_PACIENTES_MUTUAS_FAILURE, payload: error });
  }
}

function* getPacientesIdentificadores() {
  const params = {
    url: buildUrl('tipos_identificadores'),
    method: 'GET',
    body: {},
  };

  try {
    const {
      tipos_identificadores: identificadores,
    } = yield call(authRequest, params);
    yield put({ type: constants.PACIENTES_GET_IDENTIFICADORES_SUCCESS, payload: identificadores });
  } catch (error) {
    yield put({ type: constants.PACIENTES_GET_IDENTIFICADORES_FAILURE, payload: error });
  }
}

function* getPacientesCamposPersonalizados({ payload }: any) {
  const { create } = payload;

  let contexto = 'ALTA_PACIENTE';
  if (!create) contexto = 'EDICION_PACIENTE';
  const params = {
    url: buildUrl('campos_dinamicos', contexto),
    method: 'GET',
    body: {},
  };

  try {
    const {
      datos: camposPersonalizados,
    } = yield call(authRequest, params);

    yield put({ type: constants.PACIENTES_GET_PACIENTE_CAMPOS_PERSONALIZADOS_SUCCESS, payload: camposPersonalizados });
  } catch (error) {
    yield put({ type: constants.PACIENTES_GET_PACIENTE_CAMPOS_PERSONALIZADOS_FAILURE, payload: error });
  }
}

function* getPacienteUltimoEncargo({ payload }: any) {
  const { pacienteId } = payload;
  const consulta = { paciente: { valor: pacienteId, operador: 'eq' } };
  const orden = { fecha_emision: 'DESC' };
  const formData = new FormData();
  formData.append('consulta', JSON.stringify(consulta));
  formData.append('orden', JSON.stringify(orden));
  formData.append('limite', '-1');
  const params = {
    url: 'api/encargos/buscar',
    method: 'POST',
    body: formData,
  };

  try {
    const { datos } = yield call(authRequest, params);
    yield put({ type: constants.PACIENTES_GET_PACIENTE_ENCARGO_SUCCESS, payload: datos });
  } catch (error) {
    yield put({ type: constants.PACIENTES_GET_PACIENTE_ENCARGO_FAILURE, payload: error });
  }
}

function* getPacientesCamposDinamicos({ payload }: any) {
  const { create } = payload;

  let contexto = 'ALTA_PACIENTE';
  if (!create) contexto = 'EDICION_PACIENTE';

  const params = {
    url: buildUrl('campos_dinamicos', contexto),
    method: 'GET',
    body: {},
  };

  try {
    const {
      datos: camposDinamicos,
    } = yield call(authRequest, params);
    yield put({ type: constants.PACIENTES_GET_PACIENTE_CAMPOS_DINAMICOS_SUCCESS, payload: camposDinamicos });
  } catch (error) {
    yield put({ type: constants.PACIENTES_GET_PACIENTE_CAMPOS_DINAMICOS_FAILURE, payload: error });
  }
}

const getPacientesCamposDinamicosState = (state: any) => state.pacientesWorkspace.camposDinamicos;

function* setPacientesCamposDinamicos({ payload }: any) {
  const { campo_id, valor } = payload;
  // @ts-ignore
  const camposDinamicos = yield select(getPacientesCamposDinamicosState);
  const nuevosCamposDinamicos = cloneDeep(camposDinamicos);
  for (let i = 0; i < nuevosCamposDinamicos.length; i++) {
    if (nuevosCamposDinamicos[i].campo_id === campo_id) {
      nuevosCamposDinamicos[i].valor = valor;
    }
  }

  yield put({ type: constants.PACIENTES_GET_PACIENTE_CAMPOS_DINAMICOS_SUCCESS, payload: nuevosCamposDinamicos });
}

function* setPacientesRGPDCondicion({ payload }: any) {
  const { identificador, valor } = payload;
  // @ts-ignore
  const grpd = yield select(getPacientesRGPDCondicionesState);
  const nuevoGRPD = cloneDeep(grpd);
  for (let i = 0; i < nuevoGRPD.condiciones_adicionales.length; i++) {
    if (nuevoGRPD.condiciones_adicionales[i].identificador === identificador) {
      nuevoGRPD.condiciones_adicionales[i].valor = valor;
    }
  }

  yield put({ type: constants.PACIENTES_SET_PACIENTE_RGPD_CONDITIONS, payload: nuevoGRPD });
}

function* getPacienteActivityData({ payload }: any) {
  let encar: any[] = [];
  let contact: any[] = [];
  let opt: any[] = [];

  const { pacienteId } = payload;
  const consulta = { paciente: { valor: pacienteId, operador: 'eq' } };
  const orden = { fecha_emision: 'DESC' };
  const formDataEncargo = new FormData();
  formDataEncargo.append('consulta', JSON.stringify(consulta));
  formDataEncargo.append('orden', JSON.stringify(orden));
  formDataEncargo.append('limite', '20');
  const paramsEncargo = {
    url: 'api/encargos/buscar',
    method: 'POST',
    body: formDataEncargo,
  };
  function* encargosFunc() {
    try {
      const { datos: encargos } = yield call(authRequest, paramsEncargo);
      encar = encargos;
      yield put({ type: constants.PACIENTES_GET_PACIENTE_ENCARGO_SUCCESS, payload: encargos });
    } catch (error) {
      yield put({ type: constants.PACIENTES_GET_PACIENTE_ENCARGO_FAILURE, payload: error });
    }
  }
  // @ts-ignore
  const formDataContactologico = new FormData();
  formDataContactologico.append('consulta', JSON.stringify({ codigo_cliente: { valor: pacienteId } }));
  formDataContactologico.append('limite', '-1');
  formDataContactologico.append('orden', JSON.stringify({ fecha: 'DESC' }));

  const paramsContactologica = { url: 'api/graduacioncontactologica/buscar', method: 'POST', body: formDataContactologico };
  function* contactologiasFunc() {
    try {
      const { datos: contactologias } = yield call(authRequest, paramsContactologica);
      contact = contactologias;
      yield put({ type: constantsContact.GET_GRADUACIONES_CONTACT_SUCCESS, payload: contactologias });
    } catch (error) {
      yield put({ type: constantsContact.GET_GRADUACIONES_CONTACT_FAILURE, payload: error });
    }
  }

  const formDataOptometrico = new FormData();
  formDataOptometrico.append('tienda_id', '-1');
  formDataOptometrico.append('consulta', JSON.stringify({
    paciente_id: {
      valor: pacienteId,
      operador: 'eq',
    },
  }));

  const paramsOptometrico = {
    url: buildUrl('get_graduaciones'),
    method: 'POST',
    body: formDataOptometrico,
  };

  function* optometriasFunc() {
    try {
      const {
        datos: optometrias,
      } = yield call(authRequest, paramsOptometrico);
      opt = optometrias;
      yield put({ type: constantsOpto.GET_GRADUACIONES_REQUEST_SUCCESS, payload: optometrias });
    } catch (error) {
      yield put({ type: constantsOpto.GET_GRADUACIONES_REQUEST_FAILURE, payload: error });
    }
  }
  yield all([encargosFunc(), contactologiasFunc(), optometriasFunc()]);
  yield put({ type: constants.GET_ACTIVITY_DATA_SUCCESS, payload: { encargos: encar, optometrias: opt, contactologias: contact } });
  sessionStorage.setItem('infoPacienteActivityData', pacienteId);
}

function* getFotoPaciente({ payload }: any) {
  const { pacienteId } = payload;
  const params = {
    url: buildUrl('get_foto_paciente', pacienteId.pacienteId),
    method: 'GET',
    body: {},
  };

  try {
    // @ts-ignore
    const imagen = yield call(authRequest, params);
    yield put({ type: constants.GET_PHOTO_PACIENTE_REQUEST_SUCCESS, payload: imagen.imagen });
  } catch (error) {
    yield put({ type: constants.GET_PHOTO_PACIENTE_REQUEST_FAILURE, payload: error });
  }
}

export default function* pacientesSaga() {
  yield all([
    takeLatest(constants.PACIENTES_INIT_WORKSPACE, initWorkspace),
    takeLatest(constants.PACIENTES_SET_WORKSPACE, setWorkspace),
    takeLatest(constants.PACIENTES_SET_KEYWORD, setKeyword),
    takeLatest(constants.PACIENTES_GET_PACIENTES_REQUEST, getPacientes),
    takeLatest(constants.PACIENTES_GET_PACIENTE_REQUEST, getPaciente),
    takeLatest(constants.PACIENTES_GET_PACIENTES_PROFESIONES, getPacientesProfesiones),
    takeLatest(constants.PACIENTES_GET_PACIENTES_TIENDAS, getPacientesTiendas),
    takeLatest(constants.PACIENTES_GET_PACIENTES_GROUPS, getPacienteGrupos),
    takeLatest(constants.PACIENTES_CREATE_PACIENTE_REQUEST, createPaciente),
    takeLatest(constants.COMPROBAR_PACIENTE_DUPLICADO_REQUEST, comprobarPacienteDuplicado),
    takeLatest(constants.PACIENTES_UPDATE_PACIENTE_REQUEST, updatePaciente),
    takeLatest(constants.PACIENTES_GET_PACIENTE_RGPD_REQUEST, getPacienteRGPD),
    takeLatest(constants.PACIENTES_OPEN_PACIENTE_URL_AWS_RGPD_REQUEST, openPacienteUrlAwsRGPD),
    takeLatest(constants.PACIENTES_DOWNLOAD_PACIENTE_URL_AWS_RGPD_REQUEST, downloadPacienteAwsRGPD),
    takeLatest(constants.PACIENTES_OPEN_PACIENTE_URL_RGPD_REQUEST, openPacienteUrlRGPD),
    takeLatest(constants.PACIENTES_DOWNLOAD_PACIENTE_URL_RGPD_REQUEST, downloadPacienteRGPD),
    takeLatest(constants.PACIENTES_SAVE_PACIENTE_RGPD_REQUEST, savePacienteRGPD),
    takeLatest(constants.PACIENTES_SET_PACIENTE_RGPD_CONDITION, setPacientesRGPDCondicion),
    takeLatest(constants.PACIENTES_GET_PACIENTE_NOTAS_REQUEST, getPacienteNotas),
    takeLatest(constants.PACIENTES_SET_PACIENTE_NOTAS_REQUEST, setPacienteNotas),
    takeLatest(constants.PACIENTES_GET_PACIENTE_INSURANCES_REQUEST, getPacienteInsurances),
    takeLatest(constants.PACIENTES_GET_PACIENTES_PAISES, getPacientesPaises),
    takeLatest(constants.PACIENTES_GET_PACIENTES_PROVINCIAS, getPacientesProvincias),
    takeLatest(constants.PACIENTES_GET_PACIENTES_MUTUAS, getPacientesMutuas),
    takeLatest(constants.PACIENTES_GET_IDENTIFICADORES, getPacientesIdentificadores),
    takeLatest(constants.PACIENTES_GET_PACIENTE_CAMPOS_PERSONALIZADOS, getPacientesCamposPersonalizados),
    takeLatest(constants.PACIENTES_GET_PACIENTE_CAMPOS_DINAMICOS, getPacientesCamposDinamicos),
    takeLatest(constants.PACIENTES_SET_PACIENTE_CAMPOS_DINAMICOS, setPacientesCamposDinamicos),
    takeLatest(constants.PACIENTES_GET_PACIENTE_ENCARGO_REQUEST, getPacienteUltimoEncargo),
    takeLatest(constants.GET_ACTIVITY_DATA_REQUEST, getPacienteActivityData),
    takeLatest(constants.GET_PHOTO_PACIENTE_REQUEST, getFotoPaciente),
  ]);
}
